import axios from 'axios';
import { getIdToken } from './auth';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
});

api.interceptors.request.use(async (config) => {
  const token = await getIdToken();
  config.headers.Authorization = token;
  return config;
});

export const publicApi = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
});

export default api;
